import { requestGQL } from 'common/graphQlClient';
import { gql } from 'graphql-request';

export const DELETE_TRUNK = gql`
  mutation deleteTrunk($input: DeleteNodeInput!) {
    deleteTrunk(input: $input)
  }
`;

export const deleteTrunk = (propertyId: number) => (nodeId: string) => {
  return requestGQL(DELETE_TRUNK, { input: { propertyId, nodeId } });
};
